const DealStatusEnum = {
    1: {
        label: "Acordo em andamento",
        color: "#06BCED",
        key: "IN_PROGRESS"
    },
    2: {
        label: "Acordo finalizado",
        color: "#45D256",
        key: "PAID"
    },
    3: {
        label: "Acordo vencido",
        color: "#EB6878",
        key: "EXPIRED"
    },
    4: {
        label: "Acordo quebrado",
        color: "#EB6878",
        key: "DEAL_BROKED"
    }
};

export default DealStatusEnum;
